








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloActivity, AloActivity } from '@/models/alo/AloActivity';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'EditBaseActivity',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseActivity extends Vue {
  
  private original:AloActivity = getDefaultAloActivity()
  private modified:AloActivity = getDefaultAloActivity()
  private showDrawer = false
  private saving = false
    
  edit(item:AloActivity) {
    this.$store.myActions.ADM_ACTIVITY_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloActivity(),...item}    
    this.modified = cloneDeep(this.original)
    
    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get activityStatus() {
    return this.$store.myGetters.activityStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_ACTIVITY_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.activityStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
